<script setup lang="ts">
import ILxcImgNotFound from "~icons/lxc-business/not-found";

const { t } = useI18n();
</script>
<template>
  <container-component>
    <div class="m-10 flex flex-col justify-center items-center flex-1">
      <i-lxc-img-not-found />
      <h2 class="mt-10">
        {{ t("errors.pageNotFound") }}
      </h2>
    </div>
  </container-component>
</template>
